import { dispatch } from "@shared/utils.events";
import type { BaseTrackingValues } from "./types";

export const useTrackElementClicked = ({
  target,
  location
}: BaseTrackingValues): {
  elementClicked: (payload: Record<string, unknown>) => void;
} => {
  const elementClicked = (payload: Record<string, unknown>) => {
    dispatch("page element clicked", {
      target,
      ...(location && { location }),
      ...(payload && { ...payload })
    });
  };

  return {
    elementClicked
  };
};
